import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form'
import {
  updateTopHeader,
  uplodateLoading
} from '../../../redux/features/common/commonSlice'
import ApiCaller from '../../constants/ApiCaller'

import { useDispatch, useSelector } from 'react-redux'
import urls from '../../constants/apiurl'
import { showDangerToast, showToast } from '../../constants/toaster'
import NavBar from '../../structure/NavBar'
import { NavBarTop } from '../../structure/NavBarTop'
import InsufficientPermission from '../../custom/InSufficientPermission'
import { Box, Button, ButtonGroup, Collapse, Divider, Paper, Typography, Switch } from '@mui/material'
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined'
import AccountBalanceWalletOutlined from '@mui/icons-material/AccountBalanceWalletOutlined'
import AutoAwesomeOutlined from '@mui/icons-material/AutoAwesomeOutlined'
import CardGiftcardOutlined from '@mui/icons-material/CardGiftcardOutlined'
import EventAvailableOutlined from '@mui/icons-material/EventAvailableOutlined'
import GradeOutlined from '@mui/icons-material/GradeOutlined'
import GridViewOutlined from '@mui/icons-material/GridViewOutlined'
import HowToRegOutlined from '@mui/icons-material/HowToRegOutlined'
import LocalActivityOutlined from '@mui/icons-material/LocalActivityOutlined'
import LoyaltyOutlined from '@mui/icons-material/LoyaltyOutlined'
import MilitaryTechOutlined from '@mui/icons-material/MilitaryTechOutlined'
import MoreHorizOutlined from '@mui/icons-material/MoreHorizOutlined'
import PercentOutlined from '@mui/icons-material/PercentOutlined'
import PersonAddAlt1Outlined from '@mui/icons-material/PersonAddAlt1Outlined'
import PersonOffOutlined from '@mui/icons-material/PersonOffOutlined'
import RedeemOutlined from '@mui/icons-material/RedeemOutlined'
import SavingsOutlined from '@mui/icons-material/SavingsOutlined'
import ShoppingBagOutlined from '@mui/icons-material/ShoppingBagOutlined'
import ShoppingCartOutlined from '@mui/icons-material/ShoppingCartOutlined'
import SmartphoneOutlined from '@mui/icons-material/SmartphoneOutlined'
import StorefrontOutlined from '@mui/icons-material/StorefrontOutlined'
import StyleOutlined from '@mui/icons-material/StyleOutlined'
import SubscriptionsOutlined from '@mui/icons-material/SubscriptionsOutlined'
import TimerOutlined from '@mui/icons-material/TimerOutlined'
import TuneOutlined from '@mui/icons-material/TuneOutlined'
import VideocamOutlined from '@mui/icons-material/VideocamOutlined'
import './GlobalSettingList.css'
import { s3 } from '../../constants/awsConfig'

const label = { inputProps: { 'aria-label': 'Size switch demo' } }

/** Light, colourful section label (icons + pastel chip) — display only */
const GS_TONES = {
  rose: { bg: 'rgba(244, 114, 182, 0.1)', fg: '#9d174d', border: 'rgba(244, 114, 182, 0.28)' },
  sky: { bg: 'rgba(56, 189, 248, 0.12)', fg: '#0369a1', border: 'rgba(14, 165, 233, 0.28)' },
  amber: { bg: 'rgba(251, 191, 36, 0.14)', fg: '#b45309', border: 'rgba(245, 158, 11, 0.35)' },
  fuchsia: { bg: 'rgba(232, 121, 249, 0.12)', fg: '#a21caf', border: 'rgba(217, 70, 239, 0.28)' },
  teal: { bg: 'rgba(45, 212, 191, 0.12)', fg: '#0f766e', border: 'rgba(20, 184, 166, 0.3)' },
  indigo: { bg: 'rgba(129, 140, 248, 0.12)', fg: '#4338ca', border: 'rgba(99, 102, 241, 0.28)' },
  orange: { bg: 'rgba(251, 146, 60, 0.12)', fg: '#c2410c', border: 'rgba(249, 115, 22, 0.3)' },
  violet: { bg: 'rgba(167, 139, 250, 0.12)', fg: '#5b21b6', border: 'rgba(139, 92, 246, 0.28)' },
  cyan: { bg: 'rgba(34, 211, 238, 0.12)', fg: '#0e7490', border: 'rgba(6, 182, 212, 0.28)' },
  blue: { bg: 'rgba(96, 165, 250, 0.12)', fg: '#1d4ed8', border: 'rgba(59, 130, 246, 0.28)' },
  slate: { bg: 'rgba(148, 163, 184, 0.14)', fg: '#334155', border: 'rgba(100, 116, 139, 0.25)' },
  green: { bg: 'rgba(74, 222, 128, 0.12)', fg: '#166534', border: 'rgba(34, 197, 94, 0.28)' },
  emerald: { bg: 'rgba(52, 211, 153, 0.12)', fg: '#047857', border: 'rgba(16, 185, 129, 0.28)' },
  gold: { bg: 'rgba(250, 204, 21, 0.14)', fg: '#a16207', border: 'rgba(234, 179, 8, 0.35)' }
}

const REFERRAL_PROGRAM_DEFAULTS = {
  referralSignupRewardPercent: 40,
  referralTaskRewardPercent: 60,
  referralProgramDays: 7,
  referralQualifiedDaysRequired: 3,
  referralLoginDaysRequired: 3,
  referralVideosPerDay: 5,
  referralStarsPerDay: 15,
  referralProgramTimezone: 'Asia/Kolkata',
  referralReminderEnabled: true
}

const applySettingsWithDefaults = (data = {}) => {
  const merged = { ...data }
  Object.entries(REFERRAL_PROGRAM_DEFAULTS).forEach(([key, defaultVal]) => {
    if (merged[key] === undefined || merged[key] === null || merged[key] === '') {
      merged[key] = defaultVal
    }
  })
  if (merged.referralReminderEnabled === undefined || merged.referralReminderEnabled === null) {
    merged.referralReminderEnabled = true
  }
  return merged
}

const getReferralValidationErrors = (settings) => {
  const errors = []
  const signup = parseInt(settings?.referralSignupRewardPercent, 10)
  const task = parseInt(settings?.referralTaskRewardPercent, 10)
  const programDays = parseInt(settings?.referralProgramDays, 10)
  const qualifiedDays = parseInt(settings?.referralQualifiedDaysRequired, 10)
  const loginDays = parseInt(settings?.referralLoginDaysRequired, 10)

  if (!Number.isNaN(signup) && (signup < 0 || signup > 100)) {
    errors.push('Signup reward % must be between 0 and 100.')
  }
  if (!Number.isNaN(task) && (task < 0 || task > 100)) {
    errors.push('Task reward % must be between 0 and 100.')
  }
  if (
    !Number.isNaN(signup) &&
    !Number.isNaN(task) &&
    signup + task !== 100
  ) {
    errors.push('Signup reward % and task reward % must total 100.')
  }
  if (!Number.isNaN(programDays) && programDays < 1) {
    errors.push('Program window must be at least 1 day.')
  }
  if (!Number.isNaN(qualifiedDays) && qualifiedDays < 1) {
    errors.push('Qualified days required must be at least 1.')
  }
  if (!Number.isNaN(loginDays) && loginDays < 1) {
    errors.push('Login days required must be at least 1.')
  }
  if (
    !Number.isNaN(programDays) &&
    !Number.isNaN(qualifiedDays) &&
    qualifiedDays > programDays
  ) {
    errors.push('Qualified days required cannot exceed program window (days).')
  }
  if (
    !Number.isNaN(programDays) &&
    !Number.isNaN(loginDays) &&
    loginDays > programDays
  ) {
    errors.push('Login days required cannot exceed program window (days).')
  }
  if (!String(settings?.referralProgramTimezone || '').trim()) {
    errors.push('Program timezone is required.')
  }
  return errors
}

const getExportFilename = () => {
  const date = new Date().toISOString().split('T')[0]
  return `global-settings-${date}.json`
}

const downloadJsonFile = (data, filename) => {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}

const GSSectionTitle = ({ icon: Icon, tone = 'sky', children }) => {
  const t = GS_TONES[tone] || GS_TONES.sky
  return (
    <Box
      className='gs-section-title'
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        py: 0.85,
        px: 1.35,
        mb: 0.5,
        borderRadius: '12px',
        background: t.bg,
        border: `1px solid ${t.border}`,
        color: t.fg
      }}
    >
      {Icon ? <Icon sx={{ fontSize: 22, opacity: 0.92 }} /> : null}
      <Typography
        component='h2'
        variant='subtitle1'
        sx={{ fontWeight: 600, fontSize: '0.95rem', m: 0, lineHeight: 1.3, color: 'inherit' }}
      >
        {children}
      </Typography>
    </Box>
  )
}
export const GlobalSettingList = (props) => {
  const [imageFileData, setImageFileData] = useState(null)
  const [object, setObject] = useState([]);
  const [allTypeOfAds, setAllTypeOfAds] = useState([])
  const [formValues, setFormValues] = useState({})
  const userData = useSelector((state) => state?.userData)
  const [datalist, setDatalist] = useState({})
  const [loadedSettings, setLoadedSettings] = useState({})
  const dispatch = useDispatch()

  const buildSettingsPayload = (formState = datalist) => ({
    ...loadedSettings,
    ...formState,
    id: loadedSettings?.id ?? formState?.id
  })

  const handleReferralPercentChange = (field, rawValue) => {
    const numericRegex = /^[0-9\b]+$/
    if (rawValue !== '' && !numericRegex.test(rawValue)) return
    setDatalist((prevData) => {
      const next = { ...prevData, [field]: rawValue }
      if (rawValue === '') return next
      const num = Math.min(100, Math.max(0, parseInt(rawValue, 10) || 0))
      next[field] = String(num)
      if (field === 'referralSignupRewardPercent') {
        next.referralTaskRewardPercent = String(100 - num)
      } else if (field === 'referralTaskRewardPercent') {
        next.referralSignupRewardPercent = String(100 - num)
      }
      return next
    })
  }

  const handleExportJson = () => {
    downloadJsonFile(buildSettingsPayload(), getExportFilename())
  }

  const handleExportJsonFromServer = async () => {
    try {
      dispatch(uplodateLoading(true))
      const path = urls.getGlobalSetting
      const res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        downloadJsonFile(response?.data, getExportFilename())
      } else {
        showDangerToast(response.message)
      }
    } catch (error) {
      console.error(error)
      showDangerToast(error.message)
    } finally {
      dispatch(uplodateLoading(false))
    }
  }

  const referralValidationErrors = getReferralValidationErrors(datalist)
  const referralProgramExpanded = datalist?.referralEnable !== false

  const handleInputChange = (e, key) => {
    const newValue = e.target.value.replace(/[^0-9]/g, '')
    setDatalist((prevData) => ({
      ...prevData,
      [key]: newValue
    }))
  }


  const uploadImageFile = async assetFile => {
    if (!assetFile) return;

    const params = {
      Bucket: 'praxo-dev-cloud-front', // bucket name
      Key: `common/${assetFile.name}`,
      Body: assetFile,
      ContentType: assetFile.type,
      // ACL: 'public-read', // Adjust according to your needs
    };

    try {
      const data = await s3.upload(params).promise();
      console.log('Upload Success', data.Location);
      const url = data.Location.replace(
        "https://praxo-dev-cloud-front.s3.ap-south-1.amazonaws.com/",
        "https://dhwdwg726vpm7.cloudfront.net/"
      );
      console.log(url, 'url');
      return url
    } catch (error) {
      console.error('Error uploading file:', error);
      return ''
    }
  }


  const handleRateInputChange = (index, field, value) => {
    // Allow only numbers and decimal points
    const regex = /^\d*\.?\d*$/;
    if (regex.test(value)) {
      const newObject = [...object];
      newObject[index][field] = value;
      setObject(newObject);
    }


  };

  const handleImageSelect = event => {
    const file = event.target.files[0]
    setImageFileData(file)
  }

  const uploadFile = async () => {
    dispatch(uplodateLoading(true))
    const uploadedFile = await uploadImageFile(imageFileData)
    dispatch(uplodateLoading(false))
    // Update the state only if the input is numeric or empty
    setDatalist((prevData) => ({
      ...prevData,
      'shopIntroLink': uploadedFile
    }))
    // console.log(uploadedFile)
  }

  const handleUpdateMatrixSetting = async () => {
    try {
      dispatch(uplodateLoading(true))
      let path = urls.setMatrixGlobalWorldRate
      let postJson = {
        data: object
      }
      let res = await ApiCaller.post(postJson, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(uplodateLoading(false))
        showToast(response?.message)
      } else {
        dispatch(uplodateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(uplodateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }


  const setSettingData = async () => {
    if (
      (datalist?.subscriberChannelMaxPrice &&
        datalist?.subscriberChannelMinPrice &&
        datalist?.subscriberChannelMaxPrice <
        datalist?.subscriberChannelMinPrice) ||
      (datalist?.eventPriceMaxBeads &&
        datalist?.eventPriceMinBeads &&
        datalist?.eventPriceMaxBeads < datalist?.eventPriceMinBeads) ||
      (datalist?.videoMaximumSeconds &&
        datalist?.videoMinimumSeconds &&
        datalist?.videoMaximumSeconds < datalist?.videoMinimumSeconds) ||
      (datalist?.maximumBuyBeads &&
        datalist?.minimumBuyBeads &&
        datalist?.maximumBuyBeads < datalist?.minimumBuyBeads)
    ) {
      showDangerToast('Please fill correction data.')
      return
    }

    const referralErrors = getReferralValidationErrors(datalist)
    if (referralErrors.length > 0) {
      showDangerToast(referralErrors[0])
      return
    }

    try {
      dispatch(uplodateLoading(true))
      const path = urls.setGlobalSetting
      const payload = buildSettingsPayload()
      const res = await ApiCaller.post(payload, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(uplodateLoading(false))
        const saved = applySettingsWithDefaults(response?.data || {})
        setLoadedSettings(saved)
        setDatalist(saved)
        showToast(response?.message)
      } else {
        dispatch(uplodateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(uplodateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }


  const getAllTypeOfMatrix = async () => {
    try {
      dispatch(uplodateLoading(true))
      let path = urls.getAllTypeOfMatrixGlobalRate
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(uplodateLoading(false))
        setAllTypeOfAds(response?.data)
        const initialState = response?.data?.map((data) => ({
          typeId: data.typeId,
          rate: data?.rate
        })) || [];
        setObject(initialState)
      } else {
        dispatch(uplodateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(uplodateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const userPermisiions = useSelector(state => state?.permission)
  let currentModulePermission;
  let viewPermission = true;
  let editPermission = true;
  let deletePermissionVal = true;
  let activePermission = true;

  if (userPermisiions?.modules?.length > 0) {
    currentModulePermission = userPermisiions.modules.find((element) => {
      if (element.moduleId === '19') {
        return element
      }
    })?.permissions
    viewPermission = currentModulePermission.find((element) => {
      if (element.name === 'VIEW') {
        return element
      }
    }).isEnable
    editPermission = currentModulePermission.find((element) => {
      if (element.name === 'EDIT') {
        return element
      }
    }).isEnable
    deletePermissionVal = currentModulePermission.find((element) => {
      if (element.name === 'DELETE') {
        return element
      }
    }).isEnable
    activePermission = currentModulePermission.find((element) => {
      if (element.name === 'ACTIVE') {
        return element
      }
    }).isEnable
  }


  useEffect(() => {
    dispatch(updateTopHeader("Global Setting"));
  }, [])

  useEffect(() => {
    if (viewPermission) {
      getSettingList()
      if (userData.admin) {
        getAllTypeOfMatrix()
      }
    }
  }, [])

  const getSettingList = async () => {
    try {
      dispatch(uplodateLoading(true))
      let path = urls.getGlobalSetting
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(uplodateLoading(false))
        const loaded = response?.data || {}
        setLoadedSettings(loaded)
        setDatalist(applySettingsWithDefaults(loaded))
      } else {
        dispatch(uplodateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(uplodateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  return (
    <>
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
          </div>
        </div>
        {
          viewPermission ? (
            <>
              <div className='container-fluid mt--7 global-settings-page'>
                <div className='row'>
                  <div className='col text-left'>
                    <Paper elevation={0} className='gs-page-shell overflow-hidden gs-paper-surface'>
                      <Box
                        className='gs-page-toolbar'
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: 2,
                          px: { xs: 2, md: 3 },
                          py: 2.75,
                          background: 'linear-gradient(115deg, rgba(224, 231, 255, 0.55) 0%, rgba(254, 243, 199, 0.35) 42%, rgba(204, 251, 241, 0.45) 100%)',
                          borderBottom: '1px solid rgba(99, 102, 241, 0.12)'
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                          <TuneOutlined sx={{ fontSize: 36, color: 'primary.main', opacity: 0.85, mt: 0.25 }} />
                          <Box>
                          <Typography variant='h5' component='h1' sx={{ fontWeight: 700, color: '#312e81' }}>
                            Global settings
                          </Typography>
                          <Typography variant='body2' sx={{ mt: 0.5, maxWidth: 720, color: 'rgba(49, 46, 129, 0.72)' }}>
                            Configure platform limits, rewards, and app behaviour. Saving still uses the same server actions as before.
                          </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
                          <ButtonGroup size='small' variant='outlined' aria-label='Export global settings'>
                            <Button
                              startIcon={<FileDownloadOutlined />}
                              onClick={handleExportJson}
                            >
                              Export JSON
                            </Button>
                            <Button
                              startIcon={<FileDownloadOutlined />}
                              onClick={handleExportJsonFromServer}
                            >
                              Export JSON (from server)
                            </Button>
                          </ButtonGroup>
                          <button
                            type='button'
                            onClick={setSettingData}
                            className='btn btn-sm btn-primary text-white'
                            disabled={
                              (datalist?.subscriberChannelMaxPrice &&
                                datalist?.subscriberChannelMinPrice &&
                                datalist?.subscriberChannelMaxPrice <
                                datalist?.subscriberChannelMinPrice) ||
                              (datalist?.eventPriceMaxBeads &&
                                datalist?.eventPriceMinBeads &&
                                datalist?.eventPriceMaxBeads <
                                datalist?.eventPriceMinBeads) ||
                              (datalist?.videoMaximumSeconds &&
                                datalist?.videoMinimumSeconds &&
                                datalist?.videoMaximumSeconds <
                                datalist?.videoMinimumSeconds) ||
                              (datalist?.maximumWithdrawBeads &&
                                datalist?.minimumWithdrawBeads &&
                                datalist?.maximumWithdrawBeads <
                                datalist?.minimumWithdrawBeads) ||
                              (datalist?.maximumBuyBeads &&
                                datalist?.minimumBuyBeads &&
                                datalist?.maximumBuyBeads <
                                datalist?.minimumBuyBeads) ||
                              referralValidationErrors.length > 0
                            }
                          >
                            Submit
                          </button>
                        </Box>
                      </Box>
                      <Divider />
                      <Box className='gs-page-body' sx={{ px: { xs: 2, md: 3 }, py: { xs: 2, md: 3 }, background: 'linear-gradient(180deg, rgba(248, 250, 252, 0.9) 0%, #ffffff 48%, rgba(250, 245, 255, 0.35) 100%)' }}>
                      <div className='row gs-section-heading-row'>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={PersonOffOutlined} tone='rose'>Inactive user</GSSectionTitle>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={VideocamOutlined} tone='sky'>Video uploading time</GSSectionTitle>
                        </div>
                      </div>
                      <div className='row gs-panel-row'>
                        <div className='col-md-5 gs-card'>
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Profile</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.noOfProfileForReport}
                                  disabled={!editPermission}
                                  placeholder='Enter report no. for profile'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'noOfProfileForReport': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Video </Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.noOfVideoForReport}
                                  disabled={!editPermission}
                                  placeholder='Enter report no. for Video'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'noOfVideoForReport': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                        <div className='col-md-1'></div>
                        <div
                          className='col-md-5 gs-card'
                          style={{
                            border:
                              datalist?.videoMaximumSeconds != null &&
                              datalist?.videoMinimumSeconds != null &&
                              (parseInt(datalist?.videoMaximumSeconds) <
                                parseInt(datalist?.videoMinimumSeconds)
                                ? '1px solid red'
                                : '1px solid #f2e2e2')
                          }}
                        >
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Minimum(Sec)</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.videoMinimumSeconds}
                                  placeholder='Enter Minimum Seconds'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'videoMinimumSeconds': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Maximum(Sec)</Form.Label>
                                {/* Old code: */}
                                {/*
                                <Form.Control
                                  type='text'
                                  maxLength={2}
                                  disabled={!editPermission}
                                  value={datalist?.videoMaximumSeconds}
                                  placeholder='Enter Maximum Seconds'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'videoMaximumSeconds': e.target.value
                                      }))
                                    }
                                  }}
                                />
*/}
                                {/* New code: */}
                                <Form.Control
                                  type='text'
                                  maxLength={3}
                                  disabled={!editPermission}
                                  value={datalist?.videoMaximumSeconds}
                                  placeholder='Enter Maximum Seconds'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'videoMaximumSeconds': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12 text-center'>
                              {datalist?.videoMaximumSeconds != null &&
                                datalist?.videoMinimumSeconds != null &&
                                parseInt(datalist?.videoMaximumSeconds) <
                                parseInt(datalist?.videoMinimumSeconds) ? (
                                <label className='custom-error-label'>
                                  Minimum should be less then Maximum*
                                </label>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='row gs-section-heading-row'>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={AccountBalanceWalletOutlined} tone='amber'>Withdraw limit</GSSectionTitle>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={CardGiftcardOutlined} tone='fuchsia'>Sign up chips</GSSectionTitle>
                        </div>
                      </div>
                      <div className='row gs-panel-row'>
                        <div
                          className='col-md-5 gs-card'
                          style={{
                            border:
                              datalist?.maximumWithdrawBeads != null &&
                              datalist?.minimumWithdrawBeads != null &&
                              (parseInt(datalist?.maximumWithdrawBeads) <
                                parseInt(datalist?.minimumWithdrawBeads)
                                ? '1px solid red'
                                : '1px solid #f2e2e2')
                          }}
                        >
                          <div className='row p-2'>

                            <div className='col-md-6'>

                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-medium'>Enable Creator Payment </Form.Label>
                                <Form.Select
                                  value={datalist?.enableCreatorPayment}
                                  onChange={(e) =>
                                    setDatalist({
                                      ...datalist,
                                      enableCreatorPayment: e.target.value === 'true'
                                    })
                                  }
                                  size="sm"
                                  style={{ width: '120px' }}
                                >
                                  <option value={true}>Enable</option>
                                  <option value={false}>Disable</option>
                                </Form.Select>
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Debit Bank Account Number</Form.Label>
                                <Form.Control
                                  type='number'
                                  disabled={!editPermission}
                                  value={datalist?.debitBankAccountNumber}
                                  placeholder='Enter Debit Bank Account Number'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'debitBankAccountNumber': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Maximum(Amount)</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.maximumWithdrawBeads}
                                  placeholder='Enter Maximum Withdraw Beads'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'maximumWithdrawBeads': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Minimum(Amount)</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.minimumWithdrawBeads}
                                  placeholder='Enter Minimum Withdraw Chips'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'minimumWithdrawBeads': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12 text-center'>
                              {datalist?.maximumWithdrawBeads != null &&
                                datalist?.minimumWithdrawBeads != null &&
                                parseInt(datalist?.maximumWithdrawBeads) <
                                parseInt(datalist?.minimumWithdrawBeads) ? (
                                <label className='custom-error-label'>
                                  Minimum should be less then Maximum*
                                </label>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5 gs-card'>
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>No of Chips </Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.freeBeadsAfterRegistration}
                                  placeholder='Enter Free Chips given after registration'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'freeBeadsAfterRegistration': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                              <Typography
                                variant='caption'
                                component='p'
                                sx={{ color: 'text.secondary', mt: -0.5, mb: 0, lineHeight: 1.4 }}
                              >
                                Welcome bonus for new users — not part of the referral program.
                              </Typography>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='row gs-section-heading-row'>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={ShoppingCartOutlined} tone='teal'>Buy chips limit</GSSectionTitle>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={StorefrontOutlined} tone='indigo'>Shop subscription rate</GSSectionTitle>
                        </div>
                      </div>
                      <div className='row gs-panel-row'>
                        <div
                          className='col-md-5 gs-card'
                          style={{
                            border:
                              datalist?.maximumBuyBeads != null &&
                              datalist?.minimumBuyBeads != null &&
                              (parseInt(datalist?.maximumBuyBeads) <
                                parseInt(datalist?.minimumBuyBeads)
                                ? '1px solid red'
                                : '1px solid #f2e2e2')
                          }}
                        >
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Maximum(Amount)</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.maximumBuyBeads}
                                  disabled={!editPermission}
                                  placeholder='Enter Maximum Withdraw Chips'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'maximumBuyBeads': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Minimum(Amount)</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.minimumBuyBeads}
                                  disabled={!editPermission}
                                  placeholder='Enter Minimum Withdraw Chips'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'minimumBuyBeads': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12 text-center'>
                              {datalist?.maximumBuyBeads != null &&
                                datalist?.minimumBuyBeads != null &&
                                parseInt(datalist?.maximumBuyBeads) <
                                parseInt(datalist?.minimumBuyBeads) ? (
                                <label className='custom-error-label'>
                                  Minimum should be less then Maximum*
                                </label>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5 gs-card'>
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Monthly Price </Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.monthlyPriceForPostInShop}
                                  disabled={!editPermission}
                                  placeholder='Enter monthly price for post in shop'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'monthlyPriceForPostInShop': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Weekly Price </Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.weeklyPriceForPostInShop}
                                  placeholder='Enter Weekly Price for Post in Shop'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'weeklyPriceForPostInShop': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className='row gs-section-heading-row'>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={PercentOutlined} tone='orange'>Admin commission on withdraw</GSSectionTitle>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={LoyaltyOutlined} tone='violet'>Exclusive pricing</GSSectionTitle>
                        </div>
                      </div>
                      <div className='row gs-panel-row'>
                        <div className='col-md-5 gs-card'>
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Enter % of commission</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={3}
                                  value={datalist?.percentageOfCommission}
                                  disabled={!editPermission}
                                  placeholder='Enter % of commission'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'percentageOfCommission': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            {/* <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Enter % of Admin Charges</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={3}
                                  value={datalist?.adminCharges}
                                  disabled={!editPermission}
                                  placeholder='Enter % of Admin Charges'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'adminCharges': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div> */}
                          </div>
                        </div>
                        <div className='col-md-1'></div>
                        <div
                          className='col-md-5 gs-card'
                          style={{
                            border:
                              datalist?.maximumBuyBeads != null &&
                              datalist?.minimumBuyBeads != null &&
                              (parseInt(datalist?.maximumBuyBeads) <
                                parseInt(datalist?.minimumBuyBeads)
                                ? '1px solid red'
                                : '1px solid #f2e2e2')
                          }}
                        >
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Maximum(Amount)</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.maximumExclusivePrice}
                                  disabled={!editPermission}
                                  placeholder='Enter Maximum Exclusive Chips'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'maximumExclusivePrice': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Minimum(Amount)</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.minimumExclusivePrice}
                                  placeholder='Enter Minimum Exclusive Chips'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'minimumExclusivePrice': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12 text-center'>
                              {datalist?.maximumBuyBeads != null &&
                                datalist?.minimumBuyBeads != null &&
                                parseInt(datalist?.maximumBuyBeads) <
                                parseInt(datalist?.minimumBuyBeads) ? (
                                <label className='custom-error-label'>
                                  Minimum should be less then Maximum*
                                </label>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* <div
                    className='col-md-5'
                    style={{
                      border: '1px solid #f2e2e2',
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'center'
                    }}
                  >
                    <div className='beads-info'>
                      Number of Chips
                      <span className='beads-amount'>
                        <input
                          maxLength={7}
                          value={datalist?.numberOfBeadsEqual}
                          onChange={(e) =>
                            handleInputChange(e, 'numberOfBeadsEqual')
                          }
                          type='text'
                          className='custom-input'
                          placeholder=''
                        />
                      </span>
                      is equal to
                      <span className='ngn-amount'>
                        <input
                          maxLength={7}
                          value={datalist?.amountOfNGNEqual}
                          onChange={(e) =>
                            handleInputChange(e, 'amountOfNGNEqual')
                          }
                          type='text'
                          className='custom-input'
                          placeholder=''
                        />
                        INR
                      </span>
                      .
                    </div>
                  </div> */}
                      </div>

                      <div className='row gs-section-heading-row'>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={EventAvailableOutlined} tone='rose'>Event price</GSSectionTitle>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={TimerOutlined} tone='cyan'>Ad view time</GSSectionTitle>
                        </div>
                      </div>
                      <div className='row gs-panel-row'>
                        <div
                          className='col-md-5 gs-card'
                          style={{
                            border:
                              datalist?.eventPriceMaxBeads != null &&
                              datalist?.eventPriceMinBeads != null &&
                              (parseInt(datalist?.eventPriceMaxBeads) <
                                parseInt(datalist?.eventPriceMinBeads)
                                ? '1px solid red'
                                : '1px solid #f2e2e2')
                          }}
                        >
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Min Chips</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.eventPriceMinBeads}
                                  disabled={!editPermission}
                                  placeholder='Enter Min Chips'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'eventPriceMinBeads': parseInt(
                                          e.target.value
                                        )
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Max Chips</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.eventPriceMaxBeads}
                                  placeholder='Enter Max Chips'
                                  disabled={!editPermission}
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'eventPriceMaxBeads': parseInt(
                                          e.target.value
                                        )
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12 text-center'>
                              {datalist?.eventPriceMaxBeads != null &&
                                datalist?.eventPriceMinBeads != null &&
                                parseInt(datalist?.eventPriceMaxBeads) <
                                parseInt(datalist?.eventPriceMinBeads) && (
                                  <label className='custom-error-label'>
                                    Minimum should be less then Maximum*
                                  </label>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5 gs-card'>
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Sec/View </Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={5}
                                  value={datalist?.perViewSec}
                                  disabled={!editPermission}
                                  placeholder='Enter Sec/View'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'perViewSec': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className='row gs-section-heading-row'>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={SubscriptionsOutlined} tone='blue'>Subscriber channel price / month</GSSectionTitle>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={MilitaryTechOutlined} tone='gold'>Badge price</GSSectionTitle>
                        </div>
                      </div>
                      <div className='row gs-panel-row'>
                        <div
                          className='col-md-5 gs-card'
                          style={{
                            border:
                              datalist?.subscriberChannelMaxPrice != null &&
                              datalist?.subscriberChannelMinPrice != null &&
                              (parseInt(datalist?.subscriberChannelMaxPrice) <
                                parseInt(datalist?.subscriberChannelMinPrice)
                                ? '1px solid red'
                                : '1px solid #f2e2e2')
                          }}
                        >
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Min Chips</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.subscriberChannelMinPrice}
                                  placeholder='Enter Min Chips'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'subscriberChannelMinPrice': parseInt(
                                          e.target.value
                                        )
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Max Chips</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.subscriberChannelMaxPrice}
                                  disabled={!editPermission}
                                  placeholder='Enter Max Chips'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'subscriberChannelMaxPrice': parseInt(
                                          e.target.value
                                        )
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12 text-center'>
                              {datalist?.subscriberChannelMaxPrice != null &&
                                datalist?.subscriberChannelMinPrice != null &&
                                parseInt(datalist?.subscriberChannelMaxPrice) <
                                parseInt(datalist?.subscriberChannelMinPrice) && (
                                  <label className='custom-error-label'>
                                    Minimum should be less then Maximum*
                                  </label>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5 gs-card'>
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Chips </Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.badgeBeadsPrice}
                                  placeholder='Enter Chips'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'badgeBeadsPrice': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='row gs-section-heading-row'>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={HowToRegOutlined} tone='green'>Influencer eligibility</GSSectionTitle>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={StyleOutlined} tone='violet'>Scratch card limit</GSSectionTitle>
                        </div>
                      </div>
                      <div className='col-md-1'></div>
                      <div className='row gs-panel-row'>
                        <div className='col-md-5 gs-card'>
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Follower's Influencer</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.followersForInfluencer}
                                  placeholder='Enter followers for Influencer'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'followersForInfluencer': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Influencer Views</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.viewsForInfluencer}
                                  placeholder='Enter views For Influencer'
                                  className='form-control'
                                  disabled={!editPermission}
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'viewsForInfluencer': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Years Spend on platform(Month)</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.monthsSpendForInfluencer}
                                  placeholder='Enter Month'
                                  className='form-control'
                                  disabled={!editPermission}
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'monthsSpendForInfluencer': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Contact Fee(In Chips)</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.influencerContactCharge}
                                  disabled={!editPermission}
                                  placeholder='Enter Contact Fee'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'influencerContactCharge': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5 gs-card'>
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Maximum(Day)</Form.Label>
                                <Form.Control
                                  type='text'
                                  disabled={!editPermission}
                                  maxLength={8}
                                  value={datalist?.maxScratchCardPerDay}
                                  placeholder='Enter Max Scratch Card Per Day'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'maxScratchCardPerDay': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Maximum(Week)</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  value={datalist?.maxScratchCardPerWeek}
                                  disabled={!editPermission}
                                  placeholder='Enter Max Scratch Card Per Week'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'maxScratchCardPerWeek': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Maximum(Year)</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.maxScratchCardPerMonth}
                                  placeholder='Enter Max Scratch Card Per Month'
                                  className='form-control-inWidth'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'maxScratchCardPerMonth': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='row gs-section-heading-row'>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={SavingsOutlined} tone='emerald'>Influencer earning eligibility</GSSectionTitle>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={LocalActivityOutlined} tone='orange'>Cash reward settings</GSSectionTitle>
                        </div>
                      </div>
                      <div className='col-md-1'></div>
                      <div className='row gs-panel-row'>
                        <div className='col-md-5 gs-card'>
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Minimum Followers</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.minFollowersForInfluencerEarning}
                                  placeholder='Enter Minimum Followers For Influencer Earning'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'minFollowersForInfluencerEarning': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Minimum Influencer Earning By Followers</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.minInfluencerEarningByFollowers}
                                  placeholder='Enter Influencer Earning By Followers'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'minInfluencerEarningByFollowers': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Minimum Views</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.minViewsForInfluencerEarning}
                                  placeholder='Min Views'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'minViewsForInfluencerEarning': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Minimum Influencer Earning By Views</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.minInfluencerEarningByViews}
                                  placeholder='Enter Minimum Influencer Earning By Views'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'minInfluencerEarningByViews': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5 gs-card'>
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Cash Reward Amount</Form.Label>
                                <Form.Control
                                  type='text'
                                  disabled={!editPermission}
                                  maxLength={8}
                                  value={datalist?.cashRewardAmount}
                                  placeholder='Cash Reward Amount'
                                  className='form-control'
                                  onChange={(e) => {
                                    const numericRegex = /^[0-9\b]+$/
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'cashRewardAmount': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Approve Video Count</Form.Label>
                                <Form.Control
                                  type='text'
                                  disabled={!editPermission}
                                  maxLength={8}
                                  value={datalist?.approveVideoCount}
                                  placeholder='Approve Video Count'
                                  className='form-control'
                                  onChange={(e) => {
                                    const numericRegex = /^[0-9\b]+$/
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'approveVideoCount': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Enable Whatsapp Notification </Form.Label>
                                <Switch
                                  {...label}
                                  checked={datalist?.whatsappMessage}
                                  onChange={(e) =>
                                    setDatalist({
                                      ...datalist,
                                      whatsappMessage: e?.target?.checked
                                    })
                                  }
                                  size="small"
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='enableCashWithdraw'
                              >
                                <Form.Label className='text-small'>Enable Cash Withdraw</Form.Label>
                                <Switch
                                  {...label}
                                  checked={datalist?.enableCashWithdraw}
                                  onChange={(e) =>
                                    setDatalist({
                                      ...datalist,
                                      enableCashWithdraw: e?.target?.checked
                                    })
                                  }
                                  size="small"
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Approved Cash Reward</Form.Label>
                                <Form.Control
                                  type='text'
                                  disabled={!editPermission}
                                  maxLength={8}
                                  value={datalist?.videoApprovedCashRewardAmount}
                                  placeholder='Approved Cash Reward'
                                  className='form-control'
                                  onChange={(e) => {
                                    const numericRegex = /^[0-9\b]+$/
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'videoApprovedCashRewardAmount': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Coin Transfer Rate</Form.Label>
                                <Form.Control
                                  type='text'
                                  disabled={!editPermission}
                                  maxLength={8}
                                  value={datalist?.cointransferRate}
                                  placeholder='Coin Transfer Rate'
                                  className='form-control'
                                  onChange={(e) => {
                                    const numericRegex = /^[0-9\b]+$/
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'cointransferRate': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Min Coin Require to Auto Transfer</Form.Label>
                                <Form.Control
                                  type='text'
                                  disabled={!editPermission}
                                  maxLength={8}
                                  value={datalist?.minCoinNeedToAutoTransfer}
                                  placeholder='Min Coin Require to Auto Transfer'
                                  className='form-control'
                                  onChange={(e) => {
                                    const numericRegex = /^[0-9\b]+$/
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'minCoinNeedToAutoTransfer': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Tax(%)</Form.Label>
                                <Form.Control
                                  type='text'
                                  disabled={!editPermission}
                                  maxLength={3}
                                  value={datalist?.taxPercentage}
                                  placeholder='Tax(%)'
                                  className='form-control'
                                  onChange={(e) => {
                                    const numericRegex = /^[0-9\b]+$/
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'taxPercentage': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>GST(%)</Form.Label>
                                <Form.Control
                                  type='text'
                                  disabled={!editPermission}
                                  maxLength={3}
                                  value={datalist?.gstPercentage}
                                  placeholder='GST(%)'
                                  className='form-control'
                                  onChange={(e) => {
                                    const numericRegex = /^[0-9\b]+$/
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'gstPercentage': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='row gs-section-heading-row'>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={RedeemOutlined} tone='fuchsia'>Scratch card chips</GSSectionTitle>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={MoreHorizOutlined} tone='slate'>Others</GSSectionTitle>
                        </div>
                      </div>
                      <div className='row gs-panel-row'>
                        <div className='col-md-5'>
                          <div className='row'>
                            <div
                              className='col-md-12 gs-card'
                              style={{
                                border:
                                  datalist?.scratchCardMaxChips != null &&
                                  datalist?.scratchCardMinChips != null &&
                                  (parseInt(datalist?.scratchCardMaxChips) <
                                    parseInt(datalist?.scratchCardMinChips)
                                    ? '1px solid red'
                                    : '1px solid #f2e2e2')
                              }}
                            >
                              <div className='row p-2'>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Minimum(Card Chips)</Form.Label>
                                    <Form.Control
                                      type='text'
                                      disabled={!editPermission}
                                      maxLength={8}
                                      value={datalist?.scratchCardMinChips}
                                      placeholder='Enter Minimum scratch Card Chips'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Use a regular expression to check if the input is numeric
                                        const numericRegex = /^[0-9\b]+$/
                                        // Check if the input value matches the numeric regex
                                        if (
                                          numericRegex.test(e.target.value) ||
                                          e.target.value === ''
                                        ) {
                                          // Update the state only if the input is numeric or empty
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            'scratchCardMinChips': e.target.value
                                          }))
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Maximum(Card chips)</Form.Label>
                                    <Form.Control
                                      type='text'
                                      maxLength={8}
                                      disabled={!editPermission}
                                      value={datalist?.scratchCardMaxChips}
                                      placeholder='Enter Maximum scratch Card Chips'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Use a regular expression to check if the input is numeric
                                        const numericRegex = /^[0-9\b]+$/
                                        // Check if the input value matches the numeric regex
                                        if (
                                          numericRegex.test(e.target.value) ||
                                          e.target.value === ''
                                        ) {
                                          // Update the state only if the input is numeric or empty
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            'scratchCardMaxChips': e.target.value
                                          }))
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-12 text-center'>
                                  {datalist?.scratchCardMaxChips != null &&
                                    datalist?.scratchCardMinChips != null &&
                                    parseInt(datalist?.scratchCardMaxChips) <
                                    parseInt(datalist?.scratchCardMinChips) ? (
                                    <label className='custom-error-label'>
                                      Minimum should be less then Maximum*
                                    </label>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='row mt-3'>
                            <GSSectionTitle icon={PersonAddAlt1Outlined} tone='sky'>Invite friend</GSSectionTitle>
                            <div
                              className='col-md-12 gs-card'
                              style={{
                                border:
                                  datalist?.inviteFromReward != null &&
                                    datalist?.inviteToReward != null
                                    ? '1px solid #f2e2e2'
                                    : '1px solid red'
                              }}
                            >
                              <div className='row p-2'>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='referralEnable'
                                  >
                                    <Form.Label className='text-small'>Referral program enabled</Form.Label>
                                    <Switch
                                      {...label}
                                      checked={datalist?.referralEnable !== false}
                                      disabled={!editPermission}
                                      onChange={(e) =>
                                        setDatalist({
                                          ...datalist,
                                          referralEnable: e?.target?.checked
                                        })
                                      }
                                      size='small'
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Invite From Reward(Chips)</Form.Label>
                                    <Form.Control
                                      type='text'
                                      disabled={!editPermission}
                                      maxLength={8}
                                      value={datalist?.inviteFromReward}
                                      placeholder='Enter Reward'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Use a regular expression to check if the input is numeric
                                        const numericRegex = /^[0-9\b]+$/
                                        // Check if the input value matches the numeric regex
                                        if (
                                          numericRegex.test(e.target.value) ||
                                          e.target.value === ''
                                        ) {
                                          // Update the state only if the input is numeric or empty
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            'inviteFromReward': e.target.value
                                          }))
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Invite To Reward(Chips)</Form.Label>
                                    <Form.Control
                                      type='text'
                                      maxLength={8}
                                      disabled={!editPermission}
                                      value={datalist?.inviteToReward}
                                      placeholder='Enter Reward'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Use a regular expression to check if the input is numeric
                                        const numericRegex = /^[0-9\b]+$/
                                        // Check if the input value matches the numeric regex
                                        if (
                                          numericRegex.test(e.target.value) ||
                                          e.target.value === ''
                                        ) {
                                          // Update the state only if the input is numeric or empty
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            'inviteToReward': e.target.value
                                          }))
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-12'>
                                  <Typography
                                    variant='caption'
                                    component='p'
                                    sx={{ color: 'text.secondary', mb: 1, lineHeight: 1.45 }}
                                  >
                                    If inviteFromReward is 100 and signup is 40%, inviter gets 40 chips at signup and 60 after invitee completes tasks.
                                  </Typography>
                                </div>
                                <div className='col-md-12 text-center'>
                                  {datalist?.scratchCardMaxChips != null &&
                                    datalist?.scratchCardMinChips != null &&
                                    parseInt(datalist?.scratchCardMaxChips) <
                                    parseInt(datalist?.scratchCardMinChips) ? (
                                    <label className='custom-error-label'>
                                      Minimum should be less then Maximum*
                                    </label>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='row mt-3'>
                            <GSSectionTitle icon={PercentOutlined} tone='violet'>
                              Referral program (40/60 split &amp; daily tasks)
                            </GSSectionTitle>
                            <div className='col-md-12 gs-card'>
                              <Collapse in={referralProgramExpanded}>
                                <div
                                  className='row p-2'
                                  style={{
                                    opacity: referralProgramExpanded ? 1 : 0.55,
                                    pointerEvents: referralProgramExpanded && editPermission ? 'auto' : 'none'
                                  }}
                                >
                                  <div className='col-md-6'>
                                    <Form.Group className='mb-3' controlId='referralSignupRewardPercent'>
                                      <Form.Label className='text-small'>Signup reward %</Form.Label>
                                      <Form.Control
                                        type='text'
                                        maxLength={3}
                                        disabled={!editPermission || !referralProgramExpanded}
                                        value={datalist?.referralSignupRewardPercent ?? ''}
                                        placeholder='40'
                                        className='form-control'
                                        onChange={(e) =>
                                          handleReferralPercentChange(
                                            'referralSignupRewardPercent',
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className='col-md-6'>
                                    <Form.Group className='mb-3' controlId='referralTaskRewardPercent'>
                                      <Form.Label className='text-small'>Task reward %</Form.Label>
                                      <Form.Control
                                        type='text'
                                        maxLength={3}
                                        disabled={!editPermission || !referralProgramExpanded}
                                        value={datalist?.referralTaskRewardPercent ?? ''}
                                        placeholder='60'
                                        className='form-control'
                                        onChange={(e) =>
                                          handleReferralPercentChange(
                                            'referralTaskRewardPercent',
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className='col-md-6'>
                                    <Form.Group className='mb-3' controlId='referralProgramDays'>
                                      <Form.Label className='text-small'>Program window (days)</Form.Label>
                                      <Form.Control
                                        type='text'
                                        maxLength={4}
                                        disabled={!editPermission || !referralProgramExpanded}
                                        value={datalist?.referralProgramDays ?? ''}
                                        placeholder='7'
                                        className='form-control'
                                        onChange={(e) => handleInputChange(e, 'referralProgramDays')}
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className='col-md-6'>
                                    <Form.Group className='mb-3' controlId='referralQualifiedDaysRequired'>
                                      <Form.Label className='text-small'>Qualified days required</Form.Label>
                                      <Form.Control
                                        type='text'
                                        maxLength={4}
                                        disabled={!editPermission || !referralProgramExpanded}
                                        value={datalist?.referralQualifiedDaysRequired ?? ''}
                                        placeholder='3'
                                        className='form-control'
                                        onChange={(e) =>
                                          handleInputChange(e, 'referralQualifiedDaysRequired')
                                        }
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className='col-md-6'>
                                    <Form.Group className='mb-3' controlId='referralLoginDaysRequired'>
                                      <Form.Label className='text-small'>Login days required</Form.Label>
                                      <Form.Control
                                        type='text'
                                        maxLength={4}
                                        disabled={!editPermission || !referralProgramExpanded}
                                        value={datalist?.referralLoginDaysRequired ?? ''}
                                        placeholder='3'
                                        className='form-control'
                                        onChange={(e) => handleInputChange(e, 'referralLoginDaysRequired')}
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className='col-md-6'>
                                    <Form.Group className='mb-3' controlId='referralVideosPerDay'>
                                      <Form.Label className='text-small'>Videos per day</Form.Label>
                                      <Form.Control
                                        type='text'
                                        maxLength={4}
                                        disabled={!editPermission || !referralProgramExpanded}
                                        value={datalist?.referralVideosPerDay ?? ''}
                                        placeholder='5'
                                        className='form-control'
                                        onChange={(e) => handleInputChange(e, 'referralVideosPerDay')}
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className='col-md-6'>
                                    <Form.Group className='mb-3' controlId='referralStarsPerDay'>
                                      <Form.Label className='text-small'>Stars per day</Form.Label>
                                      <Form.Control
                                        type='text'
                                        maxLength={4}
                                        disabled={!editPermission || !referralProgramExpanded}
                                        value={datalist?.referralStarsPerDay ?? ''}
                                        placeholder='15'
                                        className='form-control'
                                        onChange={(e) => handleInputChange(e, 'referralStarsPerDay')}
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className='col-md-6'>
                                    <Form.Group className='mb-3' controlId='referralProgramTimezone'>
                                      <Form.Label className='text-small'>Program timezone</Form.Label>
                                      <Form.Control
                                        type='text'
                                        maxLength={64}
                                        disabled={!editPermission || !referralProgramExpanded}
                                        value={datalist?.referralProgramTimezone ?? ''}
                                        placeholder='Asia/Kolkata'
                                        className='form-control'
                                        onChange={(e) =>
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            referralProgramTimezone: e.target.value
                                          }))
                                        }
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className='col-md-6'>
                                    <Form.Group className='mb-3' controlId='referralReminderEnabled'>
                                      <Form.Label className='text-small'>Send task reminders</Form.Label>
                                      <Switch
                                        {...label}
                                        checked={datalist?.referralReminderEnabled !== false}
                                        disabled={!editPermission || !referralProgramExpanded}
                                        onChange={(e) =>
                                          setDatalist({
                                            ...datalist,
                                            referralReminderEnabled: e?.target?.checked
                                          })
                                        }
                                        size='small'
                                      />
                                    </Form.Group>
                                  </div>
                                  {referralValidationErrors.length > 0 ? (
                                    <div className='col-md-12 text-center'>
                                      <label className='custom-error-label'>
                                        {referralValidationErrors[0]}
                                      </label>
                                    </div>
                                  ) : null}
                                </div>
                              </Collapse>
                              {!referralProgramExpanded ? (
                                <Typography
                                  variant='caption'
                                  component='p'
                                  sx={{ px: 2, pb: 2, color: 'text.secondary' }}
                                >
                                  Enable referral program above to edit split and daily task settings. Values are still saved from the last loaded configuration.
                                </Typography>
                              ) : null}
                            </div>
                          </div>
                          <div className='row mt-3'>
                            <GSSectionTitle icon={AutoAwesomeOutlined} tone='amber'>Special reward program</GSSectionTitle>
                            <div
                              className='col-md-12 gs-card'
                              style={{
                                border:
                                  datalist?.inviteFromReward != null &&
                                    datalist?.inviteToReward != null
                                    ? '1px solid #f2e2e2'
                                    : '1px solid red'
                              }}
                            >
                              <div className='row p-2'>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Enable </Form.Label>
                                    <Switch
                                      {...label}
                                      checked={datalist?.specialRewardEnable}
                                      onChange={(e) =>
                                        setDatalist({
                                          ...datalist,
                                          specialRewardEnable: e?.target?.checked
                                        })
                                      }
                                      size="small"
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Video Limit For Apply</Form.Label>
                                    <Form.Control
                                      type='text'
                                      maxLength={8}
                                      disabled={!editPermission}
                                      value={datalist?.specialRewardApplyVideoLimit}
                                      placeholder='Enter Video Limit.'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Use a regular expression to check if the input is numeric
                                        const numericRegex = /^[0-9\b]+$/
                                        // Check if the input value matches the numeric regex
                                        if (
                                          numericRegex.test(e.target.value) ||
                                          e.target.value === ''
                                        ) {
                                          // Update the state only if the input is numeric or empty
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            'specialRewardApplyVideoLimit': e.target.value
                                          }))
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                              </div>
                              <div className='row p-2'>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Total Video Watch(For Approved)</Form.Label>
                                    <Form.Control
                                      type='text'
                                      maxLength={8}
                                      disabled={!editPermission}
                                      value={datalist?.totalVideoWatchForApprovedInvitedUsers}
                                      placeholder='Enter Video Limit.'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Use a regular expression to check if the input is numeric
                                        const numericRegex = /^[0-9\b]+$/
                                        // Check if the input value matches the numeric regex
                                        if (
                                          numericRegex.test(e.target.value) ||
                                          e.target.value === ''
                                        ) {
                                          // Update the state only if the input is numeric or empty
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            'totalVideoWatchForApprovedInvitedUsers': e.target.value
                                          }))
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Last Period In Days(For Approval)</Form.Label>
                                    <Form.Control
                                      type='text'
                                      maxLength={8}
                                      disabled={!editPermission}
                                      value={datalist?.totalDaysForApprovedInvitedUsersLastPeriodInDays}
                                      placeholder='Enter Video Limit.'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Use a regular expression to check if the input is numeric
                                        const numericRegex = /^[0-9\b]+$/
                                        // Check if the input value matches the numeric regex
                                        if (
                                          numericRegex.test(e.target.value) ||
                                          e.target.value === ''
                                        ) {
                                          // Update the state only if the input is numeric or empty
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            'totalDaysForApprovedInvitedUsersLastPeriodInDays': e.target.value
                                          }))
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Last Period Video Watch(For Approval)</Form.Label>
                                    <Form.Control
                                      type='text'
                                      maxLength={8}
                                      disabled={!editPermission}
                                      value={datalist?.totalVideoWatchForApprovedInvitedUsersLastPeriodInDays}
                                      placeholder='Enter Video Limit.'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Use a regular expression to check if the input is numeric
                                        const numericRegex = /^[0-9\b]+$/
                                        // Check if the input value matches the numeric regex
                                        if (
                                          numericRegex.test(e.target.value) ||
                                          e.target.value === ''
                                        ) {
                                          // Update the state only if the input is numeric or empty
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            'totalVideoWatchForApprovedInvitedUsersLastPeriodInDays': e.target.value
                                          }))
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='row mt-3'>
                            <GSSectionTitle icon={ShoppingBagOutlined} tone='teal'>Shopping introduction</GSSectionTitle>
                            <div className='col-md-12 gs-card'>
                              <div className='row p-2'>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Enable </Form.Label>
                                    <Switch
                                      {...label}
                                      checked={datalist?.shopIntroEnable}
                                      onChange={(e) =>
                                        setDatalist({
                                          ...datalist,
                                          shopIntroEnable: e?.target?.checked
                                        })
                                      }
                                      size="small"
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Video Type: </Form.Label>
                                    <Switch
                                      {...label}
                                      checked={datalist?.shopIntroVideoType}
                                      onChange={(e) =>
                                        setDatalist({
                                          ...datalist,
                                          shopIntroVideoType: e?.target?.checked
                                        })
                                      }
                                      size="small"
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-12'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Intro Link</Form.Label>
                                    <Form.Control
                                      type='text'
                                      disabled={!editPermission}
                                      value={datalist?.shopIntroLink}
                                      placeholder='Enter Video Limit.'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Update the state only if the input is numeric or empty
                                        setDatalist((prevData) => ({
                                          ...prevData,
                                          'shopIntroLink': e.target.value
                                        }))
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-12'>
                                  <div className='row'>
                                    <div className='col-md-6'>
                                      <input
                                        type="file"
                                        id="file"
                                        accept={'image/*,video/*'}
                                        onChange={(event) => handleImageSelect(event)}
                                      />
                                    </div>
                                    <div className='col-md-6'>
                                      <button
                                        onClick={() => uploadFile()}
                                        className='btn btn-sm btn-primary text-white'
                                      >
                                        Upload
                                      </button>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='row mt-3'>
                            <GSSectionTitle icon={GradeOutlined} tone='gold'>Star rewards</GSSectionTitle>
                            <div className='col-md-12 gs-card'>
                              <div className='row p-2'>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Enable </Form.Label>
                                    <Switch
                                      {...label}
                                      checked={datalist?.starRewardEnable}
                                      onChange={(e) =>
                                        setDatalist({
                                          ...datalist,
                                          starRewardEnable: e?.target?.checked
                                        })
                                      }
                                      size="small"
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Daily Top Positions</Form.Label>
                                    <Form.Control
                                      type='text'
                                      disabled={!editPermission}
                                      value={datalist?.dailyTopStarPositions}
                                      placeholder='Enter Daily Positions'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Use a regular expression to check if the input is numeric
                                        const numericRegex = /^[0-9\b]+$/
                                        // Check if the input value matches the numeric regex
                                        if (
                                          numericRegex.test(e.target.value) ||
                                          e.target.value === ''
                                        ) {
                                          // Update the state only if the input is numeric or empty
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            'dailyTopStarPositions': e.target.value
                                          }))
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Reward Coins</Form.Label>
                                    <Form.Control
                                      type='text'
                                      disabled={!editPermission}
                                      value={datalist?.dailyStarRewardChipsIndividually}
                                      placeholder='Enter Reward Coin'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Use a regular expression to check if the input is numeric
                                        const numericRegex = /^[0-9\b]+$/
                                        // Check if the input value matches the numeric regex
                                        if (
                                          numericRegex.test(e.target.value) ||
                                          e.target.value === ''
                                        ) {
                                          // Update the state only if the input is numeric or empty
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            'dailyStarRewardChipsIndividually': e.target.value
                                          }))
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Like Count</Form.Label>
                                    <Form.Control
                                      type='text'
                                      disabled={!editPermission}
                                      value={datalist?.totalLikeWithWatchForStar}
                                      placeholder='Likes'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Use a regular expression to check if the input is numeric
                                        const numericRegex = /^[0-9\b]+$/
                                        // Check if the input value matches the numeric regex
                                        if (
                                          numericRegex.test(e.target.value) ||
                                          e.target.value === ''
                                        ) {
                                          // Update the state only if the input is numeric or empty
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            'totalLikeWithWatchForStar': e.target.value
                                          }))
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                                <div className='col-md-6'>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                  >
                                    <Form.Label className='text-small'>Views Count</Form.Label>
                                    <Form.Control
                                      type='text'
                                      maxLength={8}
                                      disabled={!editPermission}
                                      value={datalist?.noOfVideosToWatchEarnScratchCard}
                                      placeholder='Views Count'
                                      className='form-control'
                                      onChange={(e) => {
                                        // Use a regular expression to check if the input is numeric
                                        const numericRegex = /^[0-9\b]+$/
                                        // Check if the input value matches the numeric regex
                                        if (
                                          numericRegex.test(e.target.value) ||
                                          e.target.value === ''
                                        ) {
                                          // Update the state only if the input is numeric or empty
                                          setDatalist((prevData) => ({
                                            ...prevData,
                                            'noOfVideosToWatchEarnScratchCard': e.target.value
                                          }))
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5 gs-card'>
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Between Reels </Form.Label>
                                <Form.Control
                                  type='text'
                                  disabled={!editPermission}
                                  maxLength={8}
                                  value={datalist?.noOfVideosBetweenTwoAds}
                                  placeholder='Enter Position'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'noOfVideosBetweenTwoAds': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Panel on Reels</Form.Label>
                                <Form.Control
                                  type='text'
                                  disabled={!editPermission}
                                  maxLength={8}
                                  value={datalist?.noOfVideosPanelOnReelAds}
                                  placeholder='Enter Position'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'noOfVideosPanelOnReelAds': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Delete Watch History(Days) </Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.noOfDaysToDeleteUserWatchHistory}
                                  placeholder='Enter no. Of Days To Delete User Watch History'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'noOfDaysToDeleteUserWatchHistory': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Story Play(Sec) </Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.storyPlayTimeInSec}
                                  placeholder='Enter story Play Time In Sec'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'storyPlayTimeInSec': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>FeedBack Email </Form.Label>
                                <Form.Control
                                  type='Email'
                                  maxLength={8}
                                  disabled={!editPermission}
                                  value={datalist?.feedBackEmail}
                                  placeholder='Enter FeedBack Email'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'feedBackEmail': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Video Reward Price </Form.Label>
                                <Form.Control
                                  type='number'
                                  maxLength={5}
                                  disabled={!editPermission}
                                  value={datalist?.videoRewardDefaultPrice}
                                  placeholder='Video Reward Price'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'videoRewardDefaultPrice': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>

                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Cashback Redirect URL: </Form.Label>
                                <Form.Control
                                  type='text'
                                  disabled={!editPermission}
                                  value={datalist?.cashbackRedirectUrl}
                                  placeholder='Enter Redirect URL'
                                  className='form-control-inWidth'
                                  onChange={(e) => {
                                    setDatalist((prevData) => ({
                                      ...prevData,
                                      'cashbackRedirectUrl': e.target.value
                                    }))
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Enable Payment For PostBoost/Ads </Form.Label>
                                <Switch
                                  {...label}
                                  checked={datalist?.enableAdsPayment}
                                  onChange={(e) =>
                                    setDatalist({
                                      ...datalist,
                                      enableAdsPayment: e?.target?.checked
                                    })
                                  }
                                  size="small"
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Video Watch Time Percentage </Form.Label>
                                <Form.Control
                                  type='number'
                                  maxLength={5}
                                  disabled={!editPermission}
                                  value={datalist?.videoWatchTimePercentage}
                                  placeholder='Video Watch Time Percentage'
                                  className='form-control'
                                  onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                      numericRegex.test(e.target.value) ||
                                      e.target.value === ''
                                    ) {
                                      // Update the state only if the input is numeric or empty
                                      setDatalist((prevData) => ({
                                        ...prevData,
                                        'videoWatchTimePercentage': e.target.value
                                      }))
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Home Screen Tutorial Text </Form.Label>
                                <Form.Control
                                  maxLength={80}
                                  disabled={!editPermission}
                                  value={datalist?.homeTutorialLabel}
                                  placeholder='Home Screen Tutorial Text'
                                  className='form-control'
                                  onChange={(e) => {
                                    setDatalist((prevData) => ({
                                      ...prevData,
                                      'homeTutorialLabel': e.target.value
                                    }))
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Trending Tutorial Text </Form.Label>
                                <Form.Control
                                  maxLength={80}
                                  disabled={!editPermission}
                                  value={datalist?.trendingTutorialLabel}
                                  placeholder='Trending Tutorial Text '
                                  className='form-control'
                                  onChange={(e) => {
                                    setDatalist((prevData) => ({
                                      ...prevData,
                                      'trendingTutorialLabel': e.target.value
                                    }))
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Create Video Tutorial Text </Form.Label>
                                <Form.Control
                                  maxLength={80}
                                  disabled={!editPermission}
                                  value={datalist?.createVideoTutorialLabel}
                                  placeholder='Create Video Tutorial Text'
                                  className='form-control'
                                  onChange={(e) => {
                                    setDatalist((prevData) => ({
                                      ...prevData,
                                      'createVideoTutorialLabel': e.target.value
                                    }))
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Chat Screen Tutorial Text </Form.Label>
                                <Form.Control
                                  maxLength={80}
                                  disabled={!editPermission}
                                  value={datalist?.chatTutorialLabel}
                                  placeholder='Chat Screen Tutorial Text'
                                  className='form-control'
                                  onChange={(e) => {
                                    setDatalist((prevData) => ({
                                      ...prevData,
                                      'chatTutorialLabel': e.target.value
                                    }))
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Profile Screen Tutorial Text </Form.Label>
                                <Form.Control
                                  maxLength={80}
                                  disabled={!editPermission}
                                  value={datalist?.profileTutorialLabel}
                                  placeholder='Profile Screen Tutorial Text'
                                  className='form-control'
                                  onChange={(e) => {
                                    setDatalist((prevData) => ({
                                      ...prevData,
                                      'profileTutorialLabel': e.target.value
                                    }))
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Shop Screen Tutorial Text </Form.Label>
                                <Form.Control
                                  maxLength={80}
                                  disabled={!editPermission}
                                  value={datalist?.shoppingTutorialLabel}
                                  placeholder='Shop Screen Tutorial Text'
                                  className='form-control'
                                  onChange={(e) => {
                                    setDatalist((prevData) => ({
                                      ...prevData,
                                      'shoppingTutorialLabel': e.target.value
                                    }))
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-12'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Praxo Tutorial Link </Form.Label>
                                <Form.Control
                                  maxLength={80}
                                  disabled={!editPermission}
                                  value={datalist?.tutorialUrl}
                                  placeholder='Shop Screen Tutorial Text'
                                  className='form-control'
                                  onChange={(e) => {
                                    setDatalist((prevData) => ({
                                      ...prevData,
                                      'tutorialUrl': e.target.value
                                    }))
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='row gs-section-heading-row'>
                        <div className='col-md-5'>
                          <GSSectionTitle icon={SmartphoneOutlined} tone='indigo'>App version</GSSectionTitle>
                        </div>
                      </div>
                      <div className='row gs-panel-row'>
                        <div className='col-md-5 gs-card'>
                          <div className='row p-2'>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>Android App Version</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={20}
                                  value={datalist?.androidAppVersion || ''}
                                  disabled={!editPermission}
                                  placeholder='Enter Android App Version'
                                  className='form-control'
                                  onChange={(e) => {
                                    setDatalist((prevData) => ({
                                      ...prevData,
                                      'androidAppVersion': e.target.value
                                    }))
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div className='col-md-6'>
                              <Form.Group
                                className='mb-3'
                                controlId='exampleForm.ControlInput1'
                              >
                                <Form.Label className='text-small'>iOS App Version</Form.Label>
                                <Form.Control
                                  type='text'
                                  maxLength={20}
                                  disabled={!editPermission}
                                  value={datalist?.iosAppVersion || ''}
                                  placeholder='Enter iOS App Version'
                                  className='form-control'
                                  onChange={(e) => {
                                    setDatalist((prevData) => ({
                                      ...prevData,
                                      'iosAppVersion': e.target.value
                                    }))
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      {
                        userData.admin &&
                        <>
                          <div className='row gs-section-heading-row'>
                            <div className='col-md-8'>
                              <GSSectionTitle icon={GridViewOutlined} tone='cyan'>Ads matrix world rate</GSSectionTitle>
                            </div>
                            <div className='col-md-4'>
                              <button
                                onClick={() => handleUpdateMatrixSetting()}
                                className='btn btn-sm btn-primary text-white'
                              >
                                Update Submit
                              </button>
                            </div>
                          </div>
                          <div className='row gs-panel-row'>
                            <div className='col-md-6 gs-card gs-matrix-card'>
                              <table>
                                <thead>
                                  <tr>
                                    {allTypeOfAds?.map((data) => (
                                      <th className='custom-matrix-th' key={data.typeId}>{data?.name}</th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    {object.map((data, index) => (
                                      <td className='custom-matrix-td' key={index}>
                                        <input
                                          style={{ maxWidth: '100px' }}
                                          value={data.rate}
                                          maxLength={8}
                                          onChange={(e) => handleRateInputChange(index, 'rate', e.target.value)}
                                        />
                                      </td>
                                    ))}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      }

                      <div className='row mb-5'></div>
                      </Box>
                    </Paper>

                  </div>
                </div>
              </div>
            </>
          ) : (<InsufficientPermission />)
        }
      </div >
    </>
  )
}
